<grid-engine-header-shell [params]="params()">
  <span></span>
</grid-engine-header-shell>
